import React, { PureComponent } from 'react';
import ReactRouterPropTypes from 'react-router-prop-types';
import { withRouter } from 'react-router-dom';
import cloneDeep from 'lodash/cloneDeep';
import queryString from 'query-string';

import { saveCar, getCar } from '../services/car.service';
import CarModel from '../models/car.model';
import {
  getCars,
  getFuelTypes,
  getModels,
} from '../../dictionary/services/dictionary.service';

import { Input, CustomSelect } from '../../common/components';
import Breadcrumb from '../../common/components/breadcrumb.component';

const initialState = {
  year: undefined,
  power: undefined,
  mileage: undefined,
  engine: undefined,
  vin: '',
  notes: '',
  manufacturer: undefined,
  model: undefined,
  company: undefined,
  fuelType: undefined,
};

const getOptionLabel = (option) => option.name;

const getOptionValue = (option) => option.id;

class Car extends PureComponent {
  state = cloneDeep(initialState);

  async componentDidMount() {
    const {
      location,
      match: { params },
    } = this.props;
    let car = {};
    const { company } = queryString.parse(location.search);

    const { data: cars } = await getCars({ size: 1000 });
    const { data: fuelTypes } = await getFuelTypes({ size: 1000 });

    if (params.id) {
      car = await getCar(params.id);
    }

    this.setState({
      ...car,
      company,
      cars,
      fuelTypes,
    });
  }

  onInputChange = (name, value) => this.setState({ [name]: value });

  onSelectChange = ({ id: name }, value) => {
    this.setState({ [name]: value });
  };

  onManufacturerChange = async (_, manufacturer) => {
    const { data: models } = await getModels({
      manufacturer: manufacturer.id,
      size: 1000,
    });

    this.setState({
      manufacturer,
      models,
    });
  };

  onFormSave = async () => {
    const { history } = this.props;
    const { cars, models, fuelTypes, errors: oldErrors, ...rest } = this.state;

    const carModel = new CarModel(rest);
    const errors = carModel.validate();

    if (!errors) {
      try {
        await saveCar(carModel.getData());
        history.replace('/cars');
      } catch (err) {
        console.log(err);
      }
    }

    this.setState({ errors });
  };

  render() {
    const {
      cars,
      models,
      fuelTypes,
      year,
      power,
      mileage,
      engine,
      vin,
      notes,
      manufacturer,
      model,
      fuelType,
      errors,
    } = this.state;

    const {
      match: { params },
    } = this.props;
    const title = params.id ? 'Edycja samochodu' : 'Dodawanie nowego samochodu';

    return (
      <>
        <Breadcrumb title={title} />
        <div className="content">
          <div className="card">
            <div className="card-header">Dane samochodu</div>
            <div className="card-body card-block">
              <div className="form-horizontal">
                <Input
                  label="VIN"
                  id="vin"
                  value={vin}
                  onChange={this.onInputChange}
                  errors={errors}
                  horizontal
                />
                <div className="row form-group">
                  <div className="col col-md-3">
                    <label className="form-control-label">Marka</label>
                  </div>
                  <div className="col-12 col-md-9">
                    <CustomSelect
                      data={{ id: 'manufacturer' }}
                      value={manufacturer}
                      onChange={this.onManufacturerChange}
                      options={cars}
                      getOptionLabel={getOptionLabel}
                      getOptionValue={getOptionValue}
                      errors={errors}
                    />
                  </div>
                </div>

                <div className="row form-group">
                  <div className="col col-md-3">
                    <label className="form-control-label">Model</label>
                  </div>
                  <div className="col-12 col-md-9">
                    <CustomSelect
                      data={{ id: 'model' }}
                      value={model}
                      onChange={this.onSelectChange}
                      options={models}
                      getOptionLabel={getOptionLabel}
                      getOptionValue={getOptionValue}
                      errors={errors}
                    />
                  </div>
                </div>

                <div className="row form-group">
                  <div className="col col-md-3">
                    <label htmlFor="fuelType" className="form-control-label">
                      Rodzaj paliwa
                    </label>
                  </div>
                  <div className="col-12 col-md-9">
                    <CustomSelect
                      data={{ id: 'fuelType' }}
                      value={fuelType}
                      onChange={this.onSelectChange}
                      options={fuelTypes}
                      getOptionLabel={getOptionLabel}
                      getOptionValue={getOptionValue}
                      errors={errors}
                    />
                  </div>
                </div>

                <Input
                  label="Pojemność [cm3]"
                  id="engine"
                  value={engine}
                  onChange={this.onInputChange}
                  errors={errors}
                  horizontal
                />

                <Input
                  label="Moc [kW]"
                  id="power"
                  value={power}
                  onChange={this.onInputChange}
                  errors={errors}
                  horizontal
                />

                <Input
                  label="Przebieg [km]"
                  id="mileage"
                  value={mileage}
                  onChange={this.onInputChange}
                  errors={errors}
                  horizontal
                />

                <Input
                  label="Rok produkcji"
                  id="year"
                  value={year}
                  onChange={this.onInputChange}
                  errors={errors}
                  horizontal
                />

                <Input
                  controlType="textarea"
                  label="Dodatkowe informacje"
                  id="notes"
                  value={notes}
                  onChange={this.onInputChange}
                  errors={errors}
                />
              </div>
              <div className="d-flex justify-content-end p-4">
                <button
                  type="button"
                  onClick={this.onFormSave}
                  className="btn btn-primary btn-sm"
                >
                  Zapisz
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

Car.defaultProps = {};

Car.propTypes = {
  history: ReactRouterPropTypes.history.isRequired,
  location: ReactRouterPropTypes.location.isRequired,
  match: ReactRouterPropTypes.match.isRequired,
};

export default withRouter(Car);
